import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { INotifications } from '../../services/notifications/notifications.type';
import { selectNotificationsWithoutLikes } from 'src/app/data/store/selectors/notifications.selectors';
import { Observable } from 'rxjs';
import { EntityForNotification, TextSizes, TextType } from '../../enums';
import { animate, style, transition, trigger } from '@angular/animations';
import { AsyncPipe, SlicePipe } from '@angular/common';
import { ImageComponent } from '../image/image.component';
import { TextComponent } from '../text/text.component';
import { AddBaseUrlPipe } from '../../pipe/add-baseUrl/add-base-url.pipe';
import { GetFullNamePipe } from '../../pipe/get-full-name/get-full-name.pipe';
@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
  animations: [
    trigger('appearance', [
      transition(':enter', [
        style({ transform: 'translateY(20%)', opacity: 0 }),
        animate('350ms ease-in', style({ transform: 'translateY(0%)', opacity: 1 })),
      ]),
      transition(':leave', [animate('350ms ease-in', style({ opacity: 0 }))]),
    ]),
  ],
  imports: [ImageComponent, TextComponent, AsyncPipe, SlicePipe, AddBaseUrlPipe, GetFullNamePipe],
})
export class NotificationContainerComponent {
  private _store = inject(Store);

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public readonly notificationTypes = EntityForNotification;

  public notifications$: Observable<INotifications[] | null> = this._store.select(
    selectNotificationsWithoutLikes,
  );
}
